<div class="legal">
  <h2>协议管理</h2>
  <div class="legal-container">
    <div class="toolbar">
      <label class="filter-field">
        协议类型
        <select v-model="selectedDocType" @change="handleFilterChange" :disabled="loading">
          <option value="">全部类型</option>
          <option v-for="type in DOC_TYPE_OPTIONS" :key="type.value" :value="type.value">
            {{ type.label }}
          </option>
        </select>
      </label>
      <label class="filter-field">
        状态
        <select v-model="selectedStatus" @change="handleFilterChange" :disabled="loading">
          <option value="">全部状态</option>
          <option v-for="status in STATUS_OPTIONS" :key="status.value" :value="status.value">
            {{ status.label }}
          </option>
        </select>
      </label>
      <label class="filter-field">
        搜索
        <input
          v-model="searchQuery"
          type="text"
          placeholder="标题或版本号"
          @input="handleSearch"
          :disabled="loading"
        />
      </label>
      <button class="primary-btn" @click="openCreateModal" :disabled="loading">新增协议</button>
    </div>

    <div class="table-container">
      <div v-if="loading" class="loading-wrapper">
        <div class="loading-spinner"></div>
        <span>加载中...</span>
      </div>

      <table v-else class="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>协议类型</th>
            <th>标题</th>
            <th>版本号</th>
            <th>状态</th>
            <th>当前版本</th>
            <th>生效时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="documentList.length === 0">
            <td colspan="8" class="empty-text">暂无协议</td>
          </tr>
          <tr v-else v-for="item in documentList" :key="pickDocumentId(item)">
            <td>{{ pickDocumentId(item) }}</td>
            <td>{{ formatDocType(item.doc_type || item.docType) }}</td>
            <td class="title-cell">{{ item.title }}</td>
            <td>{{ item.version }}</td>
            <td>
              <span :class="statusClass(item.status)">{{ formatStatus(item.status) }}</span>
            </td>
            <td>
              <span v-if="isCurrent(item)" class="current-tag">是</span>
              <span v-else class="muted-text">否</span>
            </td>
            <td>{{ item.effective_time || item.effectiveTime || '-' }}</td>
            <td class="action-column">
              <button class="action-btn edit-btn" @click="openDetailModal(item)">
                {{ isDraft(item) ? '编辑' : '查看' }}
              </button>
              <button
                v-if="!isDraft(item)"
                class="action-btn save-sort-btn"
                @click="openCreateFromDocument(item)"
              >
                复制为草稿
              </button>
              <button
                v-if="isDraft(item)"
                class="action-btn publish-btn"
                @click="handlePublish(item)"
              >
                发布
              </button>
              <button
                v-if="isPublished(item) && !isCurrent(item)"
                class="action-btn save-sort-btn"
                @click="handleSetCurrent(item)"
              >
                设为当前
              </button>
              <button
                v-if="isPublished(item)"
                class="action-btn delete-btn"
                @click="handleOffline(item)"
              >
                下线
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="documentList.length > 0" class="pagination">
        <button
          class="page-btn"
          :disabled="currentPage === 1 || loading"
          @click="handlePageChange(currentPage - 1)"
        >
          上一页
        </button>
        <span class="page-info">第 {{ currentPage }} 页 / 共 {{ totalPages }} 页，共 {{ total }} 条</span>
        <button
          class="page-btn"
          :disabled="currentPage === totalPages || loading"
          @click="handlePageChange(currentPage + 1)"
        >
          下一页
        </button>
      </div>
    </div>
  </div>

  <div v-if="modalVisible" class="modal-mask" @click="closeModal">
    <div class="modal-panel detail-panel" @click.stop>
      <div class="detail-header">
        <h3>{{ modalMode === 'create' ? '新增协议' : (isDraft(form) ? '编辑协议' : '协议详情') }}</h3>
        <button class="link-btn" @click="closeModal" :disabled="saving">关闭</button>
      </div>

      <div v-if="detailLoading" class="detail-loading">加载中...</div>
      <div v-else class="detail-body">
        <div class="form-grid">
          <div class="form-group">
            <label>协议类型 <span class="required">*</span></label>
            <select
              v-model="form.doc_type"
              :disabled="(modalMode === 'edit' && !isDraft(form)) || saving"
            >
              <option v-for="type in DOC_TYPE_OPTIONS" :key="type.value" :value="type.value">
                {{ type.label }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>状态</label>
            <select v-model="form.status" :disabled="modalMode === 'edit' || saving">
              <option v-for="status in STATUS_OPTIONS" :key="status.value" :value="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label>标题 <span class="required">*</span></label>
            <input v-model="form.title" type="text" :disabled="modalMode === 'edit' && !isDraft(form)" />
          </div>
          <div class="form-group">
            <label>版本号 <span class="required">*</span></label>
            <input v-model="form.version" type="text" placeholder="v1.0.0" :disabled="modalMode === 'edit' && !isDraft(form)" />
          </div>
          <div class="form-group">
            <label>生效时间</label>
            <input
              v-model="form.effective_time"
              type="text"
              placeholder="2026-05-26 00:00:00"
              :disabled="modalMode === 'edit' && !isDraft(form)"
            />
          </div>
          <label v-if="modalMode === 'create'" class="checkbox-field">
            <input v-model="form.is_current" type="checkbox" :disabled="saving" />
            设为当前版本
          </label>
        </div>

        <div class="form-group">
          <label>协议内容 HTML <span class="required">*</span></label>
          <textarea
            v-model="form.content"
            rows="14"
            placeholder="<h1>用户协议</h1><p>...</p>"
            :disabled="modalMode === 'edit' && !isDraft(form)"
          ></textarea>
        </div>

        <p class="hint-text">
          后端限制：只有草稿可编辑；已发布 / 已下线请先点「复制为草稿」，修改后再发布。
        </p>

        <div class="modal-actions">
          <button class="secondary-btn" @click="closeModal" :disabled="saving">取消</button>
          <button
            v-if="modalMode === 'edit' && !isDraft(form)"
            class="primary-btn"
            @click="openCreateFromDocument(form)"
            :disabled="saving || detailLoading"
          >
            复制为草稿并编辑
          </button>
          <button
            v-if="modalMode === 'create' || isDraft(form)"
            class="primary-btn"
            @click="handleSave"
            :disabled="saving"
          >
            {{ saving ? '保存中...' : '保存' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
